import { Group, Image } from "@mantine/core";
import React from "react";

interface ImageProps {
  source: string;
  height?: number;
}

function Logos() {
  const LogoHolder = (props: ImageProps) => {
    const { source, height } = props;
    return (
      <Image
        width={80}
        height={height ? height : 40}
        py={0}
        fit="contain"
        src={source}
      />
    );
  };

  return (
    <>
      <Group position="left" spacing="sm" mt={40}>
        <LogoHolder source="images/logos/visa-logo1.png" height={15} />
        <LogoHolder source="images/logos/mastercard-logo.png" height={30} />
        <LogoHolder source="images/logos/jcb-logo.png" height={35} />
        <LogoHolder source="images/logos/gcash-logo2.png" />
        <LogoHolder source="images/logos/metrobank-logo-3300x522.png" />
        <LogoHolder source="images/logos/bdo-whitelogo.png" height={15} />
        <LogoHolder source="images/logos/allbank-logo.png" height={15} />
        <LogoHolder source="images/logos/landbank-logolong.png" height={15} />
        <LogoHolder source="images/logos/rizalcommercialbankingcorporation-logo-whitebackground.png" />
        <LogoHolder source="images/logos/starpay-logo.png" height={20} />
        <LogoHolder source="images/logos/cebuanalhuillierruralbank-1.png" />
        <LogoHolder source="images/logos/unionbank-Logo-1468x366.png" />
        <LogoHolder source="images/logos/aub-whitelogo.png" height={15} />
        <LogoHolder source="images/logos/ussc-moneyservices2.png" height={15} />
        <LogoHolder source="images/logos/chinabank-whitelogo.png" />
      </Group>
    </>
  );
}

export default Logos;
